<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="订单状态" prop="status" style="width: 80%">
                <el-select
                  v-model="searchForm.status"
                  clearable filterable
                  placeholder="请选择订单状态"
                >
                  <el-option label="待支付" :value="0"></el-option>
                  <el-option label="取消支付" :value="1"></el-option>
                  <el-option label="待完成" :value="2"></el-option>
                  <el-option label="已完成" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单编号" prop="orderNo" style="width: 80%">
                <el-input
                  v-model="searchForm.orderNo"
                  placeholder="请输入订单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="mainNo" label="订单编号" align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="订单状态"
          align="center"
          :formatter="orderList"
        >
        </el-table-column>
        <el-table-column prop="residuePrice" label="订单价格" align="center">
        </el-table-column>
        <el-table-column prop="name" label="收货人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column prop="allAddress" label="收货地址" align="center">
        </el-table-column>
        <el-table-column
          prop="transportType"
          label="配送方式"
          align="center"
          :formatter="typeList"
        >
        </el-table-column>
        <el-table-column prop="quantity" label="购买数量" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="see(scope.row)"
              >查看订单</el-button
            >
            <el-button
              v-if="scope.row.status == 0"
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >取消订单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog title="取消订单" :visible.sync="dialogVisible" width="50%">
        <el-form ref="forms" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="信息描述" prop="cancelDes">
            <el-input
              type="textarea"
              v-model="form.cancelDes"
              placeholder="请输入信息描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="订单详情" :visible.sync="dialogVisibles" width="50%">
        <el-form ref="form" :model="addData" label-width="80px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单编号" prop="mainNo">
                <el-input
                  v-model="addData.mainNo"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预约时间" prop="deliveryTime">
                <el-input
                  v-model="addData.deliveryTime"
                  disabled
                  placeholder="无"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>          
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货人" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="des">
                <el-input
                  v-model="addData.phone"
                  disabled
                  placeholder="无"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货地址" prop="allAddress">
                <el-input
                  v-model="addData.allAddress"
                  placeholder="无"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="配送方式" prop="transportType">
                <el-select
                  v-model="addData.transportType"
                  disabled
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option label="上门配送" :value="1"></el-option>
                  <el-option label="门店自提" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-for="(item, ind) in addData.list" :key="ind">
            <el-row>
              <el-col :span="12">
                <el-form-item label="商品名称">
                  <el-input
                    v-model="item.canteenFoodName"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品价格">
                  <el-input
                    v-model="item.unitPrice"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商品数量">
                  <el-input
                    v-model="item.quantity"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品图片">
                  <img :src="item.canteenFoodImg" alt="" width="70" height="70" />
                </el-form-item>
              </el-col>
            </el-row>            
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibles = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisibles: false,
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      form: {
        orderMainCanteenId:'',
        cancelDes: "",
      },
      rules: {
        cancelDes: [{ required: true, message: "请输入取消描述", trigger: "blur" }],
      },
      addData: {},
      isShowloading: false,
      searchForm: {
        status: "",
        orderNo: "",
      },
      orderId: "",
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    see(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.dialogVisibles = true;
    },
    // 取消订单
    updataCharacter(row) {
      this.form.orderMainCanteenId = row.id;
      this.dialogVisible = true;
    },
    submit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          this.$Apis.canteenOrderCancel(this.form).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg)
              this.dialogVisible = false;
              this.onLoad()
            }else{
              this.$message.warning(res.msg)
            }
          })
        }
      });
    },
    typeList(row) {
      if (row.transportType == 1) {
        return "上门送货";
      } else if (row.transportType == 2) {
        return "门店自提";
      }
    },
    orderList(row) {
      if (row.status == 0) {
        return "待支付";
      } else if (row.status == 1) {
        return "取消支付";
      } else if (row.status == 2) {
        return "待完成";
      } else if (row.status == 5) {
        return "订单完成";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      if(ind == 1){
        this.currentPage = 1
      }
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.tableData = [];
      this.$Apis.canteenOrderList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
</style>